export default __webpack_public_path__ + "static/media/photo--sm--pam1.ecf54083.jpg";